import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/auth/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageCarousel from "../components/ImageCarousal";
import "../app/App.css";

const imagesData = {
    HOME: [
        "/static/img/home/home-1.jpg",
        "/static/img/home/home-2.jpg",
    ],

    KRPC: [
        "https://jaxa.krpc.jp/static/11b7ac71fb4a6a1c888db4da0c463a06/6_03.jpg",
        "/static/img/krpc/enigma-system.jpg",
        "/static/img/krpc/enigma-system-2.jpg",
        "/static/img/krpc/team_paragon.jpg",
        "/static/img/krpc/team_mukul.jpg",
        "https://jaxa.krpc.jp/static/ed2fd2f264779b67208cf1c316cad28b/6_05.jpg",
        "/static/img/krpc/team_cortex.jpg",
    ],

    SSAF: [
        "/static/img/ahis/Ahis-1.jpg",
        "/static/img/ahis/Ahis-2.jpg",
        "/static/img/ahis/Ahis-3.jpg",
        "/static/img/ahis/Ahis-4.jpg",
    ],

    ATZG: [
        "/static/img/atzg/atzg-1.png",
        "/static/img/atzg/atzg-2.png",
        "/static/img/atzg/atzg-3.png",
        "/static/img/atzg/atzg-4.png",
    ],
};

function HtmlEditor() {
    const { contentId } = useParams();
    const location = useLocation();

    let isHomePage = location.pathname === "/";

    const pageKey =
        contentId ||
        (isHomePage ? "home" : "");

    const normalizedKey = pageKey?.trim().toLowerCase();

    let imageKey = "";

    if (normalizedKey.includes("krpc")) {
        imageKey = "KRPC";
        import("../app/styles/kibo.css");
    } else if (normalizedKey.includes("atzg")) {
        imageKey = "ATZG";
        import("../app/styles/atzg.css");
    } else if (normalizedKey.includes("ssaf")) {
        imageKey = "SSAF";
        import("../app/styles/ssaf.css");
    } else if (normalizedKey.includes("10space-harvest-ideathon")) {
        imageKey = "10space-harvest-ideathon";
        import("../app/styles/ssaf.css"); 
     } else if (normalizedKey.includes("about")) {
        imageKey = "about";    
        import("../app/styles/about.css");          
     } else if (normalizedKey.includes("platform")) {
        imageKey = "platform";    
        import("../app/styles/platform.css");
    } else if (normalizedKey.includes("journey")) {
        imageKey = "journey";    
        import("../app/styles/founders.css");    
    } else if (normalizedKey.includes("advisor")) {
        imageKey = "advisor";    
        import("../app/styles/advisors.css");  
    } else if (normalizedKey.includes("students")) {
        imageKey = "students";    
        import("../app/styles/students.css");  
     } else if (normalizedKey.includes("achievements")) {
        imageKey = "achievements";    
        import("../app/styles/students.css");          
    } else if (normalizedKey.includes("programs")) {
        isHomePage = true;
    } else if (normalizedKey.includes("labs")) {
        isHomePage = true;
    } else {
        imageKey = normalizedKey.toUpperCase(); // fallback (optional)
    }

    const images = imagesData[imageKey] || [];

    const { user } = useAuth();
    const isAdmin = user?.role === "admin";

    const [lang, setLang] = useState("en");
    const [html, setHtml] = useState("");
    const [originalHtml, setOriginalHtml] = useState("");
    const [saving, setSaving] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        loadHtml();
    }, [pageKey, lang]);

    const loadHtml = async () => {
        if (!pageKey) return;

        try {
            console.log("PAGE_KEY", pageKey);
            const res = await fetch(`/api/html/${pageKey}?lang=${lang}`);

            if (!res.ok) return;

            const data = await res.json();

            setHtml(data.html || "");
            setOriginalHtml(data.html || "");
        } catch (err) {
            console.error(err);
        }
    };

    const saveHtml = async () => {
        if (!pageKey) return;

        setSaving(true);

        try {
            const res = await fetch(`/api/html/${pageKey}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    [lang]: html,
                }),
            });

            if (res.ok) {
                setOriginalHtml(html);
                setIsEditing(false);
                alert("Saved");
            } else {
                alert("Failed to save");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    const previewHtml = () => {
        const win = window.open("", "_blank");
        win.document.open();
        win.document.write(html);
        win.document.close();
    };

    const cancelChanges = () => {
        setHtml(originalHtml);
        setIsEditing(false);
    };

    const hasChanges = html !== originalHtml;

    // ---------------- PUBLIC VIEW ----------------
    if (!isAdmin) {
        return (
            <div>
                {/* No carousel on homepage */}
                {!isHomePage && images.length > 0 && (
                    <ImageCarousel images={images} />
                )}

                {/* <div style={{ marginBottom: 10 }}>
                    <button onClick={() => setLang("en")}>EN</button>
                    <button onClick={() => setLang("bn")}>বাংলা</button>
                </div> */}

                <div
                    className={isHomePage ? "" : "container mt-4"}
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        );
    }

    // ---------------- ADMIN VIEW ----------------
    return (
        <div>
            {/* No carousel on homepage */}
            {!isHomePage && images.length > 0 && (
                <ImageCarousel images={images} />
            )}

            {/* <div style={{ marginBottom: 10 }}>
                <button onClick={() => setLang("en")}>English</button>{" "}
                <button onClick={() => setLang("bn")}>বাংলা</button>
            </div> */}

            {!isEditing ? (
                <div className={isHomePage ? "" : "container mt-4"}>
                    <button
                        className="btn btn-primary mb-3"
                        onClick={() => setIsEditing(true)}
                    >
                        Edit {lang.toUpperCase()}
                    </button>

                    <div dangerouslySetInnerHTML={{ __html: html }} />
                </div>
            ) : (
                <div className={isHomePage ? "" : "container mt-4"}>
                    <textarea
                        value={html}
                        onChange={(e) => setHtml(e.target.value)}
                        rows={25}
                        style={{
                            width: "100%",
                            fontFamily: "monospace",
                        }}
                    />

                    <div className="mt-3">
                        <button
                            className="btn btn-success me-2"
                            onClick={saveHtml}
                            disabled={saving || !hasChanges}
                        >
                            {saving ? "Saving..." : "Save"}
                        </button>

                        <button
                            className="btn btn-secondary me-2"
                            onClick={previewHtml}
                        >
                            Preview
                        </button>

                        <button
                            className="btn btn-warning me-2"
                            onClick={cancelChanges}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-danger"
                            onClick={() => setIsEditing(false)}
                        >
                            Exit
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HtmlEditor;